import React, { useState, useEffect, useRef } from 'react';
import './QuranClassesFee.css'; // Dedicated page styles
import PricingAndStates from '../components/PricingAndStates';
import ConsultationSection from '../components/ConsultationSection';

const testimonials = [
  {
    quote: "Living in middle of North Carolina and having no tutor of Quran, my friend told me about AlQuranlesson.Com. I was eager to start but I was having no knowledge about computer … we bought a computer with broadband internet connection. We soon started Quran Learning online and now my 3 daughters have Started Quran. My daughters took classes 3 days a week. When my daughters recite Quran wearing there headphones it really gives me a great relaxation! I will highly recommend you all to try once.",
    name: "Sister Fatima"
  },
  {
    quote: "My son Hameddo Khilji who is just 4 years is having his classes from AlQuranlesson.Com. First we thought it will not work but now we are 100% satisfied with his fast progress as he is about to finish his Qaida. I am very thankful to AlQuranLesson.com.",
    name: "Fallou Khilji Texas"
  },
  {
    quote: "Being a University Professor and having a busy life I could not search for a Quran Teacher in a non-Muslim country. There is one mosque near to me which is 115 kms away from my residency therefore I searched for Quran lesson online and found AlQuranlesson.com. I'm making a great progress and very fluent in reciting than ever before. My two children are also learning Qur'an from Alquranlesson.com. I will suggest all Muslim brothers and sisters to try as they provide free trials as well!!!",
    name: "Dr.Alwaz Hussain"
  },
  {
    quote: "Assalamalaiku, It was my eldest daughter, 16 yrs old, last year who told me about Alquranlesson.com. Being in Maryland, USA it is always difficult to have access to the places where children can learn Quran recitation. It was unfortunate that as parents we were not committed and effective enough to fulfill our duties in this regard. I started to look for unconventional methods including Internet for this purpose and one day, my daughter was on the net searching when she found Alquranlesson.com. It seemed the best option under the circumstances and I did not take any time deciding to sign with AlQuranLesson. Elder daughter has already finished Qaida(Beginner Book), Alhomdulillah, and Hajrah with more than half of Qaida finished, gives me a great feeling of satisfaction. Quite a few number of my friends also joined Alquranlesson.com.",
    name: "Dr.Addoz Kamal , Arizona"
  },
  {
    quote: "My one daughter finished Quran in 8 months and other daughter who is 8 and is on 18 parah. My children are very glad to be their students. My other daughter who is 4 will also start soon from AlQuranlesson.Com. In a non Muslim country we had such a great opportunity it's not less than any blessings of Allah Almighty on us. Several families have started learning from AlquranLesson.com with our reference and recommendations. Thanks AlQuran!",
    name: "Niazuddin Sheikh Alaska"
  }
];

const QuranClassesFee = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const timerRef = useRef(null);

  const startAutoSlide = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActiveSlide((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    }, 4000);
  };

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(timerRef.current);
  }, []);

  const prevSlide = () => {
    setActiveSlide((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
    startAutoSlide();
  };

  const nextSlide = () => {
    setActiveSlide((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    startAutoSlide();
  };

  const goToSlide = (i) => {
    setActiveSlide(i);
    startAutoSlide();
  };

  return (
    <div className="about-page" id="quran-classes-fee-page">
      {/* Premium Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">Quran Classes Fee &amp; Study Plan</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">Home</a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Quran Classes Fee</span>
          </nav>
        </div>
      </section>

      {/* Fee Structure Section */}
      <section className="fee-structure-section">
        <div className="fee-structure__container">
          <div className="fee-structure__content">
            <h2 className="fee-structure__badge">FEE STRUCTURE</h2>
            <p className="fee-structure__title">We have developed a progressive fee structure</p>
            <ul className="fee-structure__list">
              <li className="fee-structure__item">
                <span className="fee-structure__bullet">&bull;</span>
                <span className="fee-structure__text">We will provide 3 free trials of individual lessons</span>
              </li>
              <li className="fee-structure__item">
                <span className="fee-structure__bullet">&bull;</span>
                <span className="fee-structure__text">You can also get individual lessons at the lowest possible cost as low as $20 per month</span>
              </li>
              <li className="fee-structure__item">
                <span className="fee-structure__bullet">&bull;</span>
                <span className="fee-structure__text">Get 10% discount on the second student</span>
              </li>
              <li className="fee-structure__item">
                <span className="fee-structure__bullet">&bull;</span>
                <span className="fee-structure__text">The below-mentioned cost is exclusive of 3 free trial classes and is implemented on monthly basis after the satisfaction of the trial period</span>
              </li>
            </ul>
          </div>
          <div className="fee-structure__image">
            <img src={`${process.env.PUBLIC_URL}/assets/images/pricing-1.webp`} alt="Fee Structure Boy Reading Quran" />
          </div>
        </div>
      </section>

      {/* Pricing and Packages Section */}
      <PricingAndStates
        badge="Same pricing for all courses"
        title="PRICING"
        subtitle="No Additional charges, Pay online using a card or PayPal & get rid of the transaction fee"
        hideStates={true}
      />

      {/* Steps Section */}
      <section className="fee-steps-section">
        <div className="fee-steps__container">
          <div className="fee-steps__item">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/step-1.webp`}
              alt="Step 1 - Join Trial"
              className="fee-steps__icon"
            />
            <p className="fee-steps__label">JOIN TRIAL</p>
          </div>
          <div className="fee-steps__item">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/step-2.webp`}
              alt="Step 2 - Assessment"
              className="fee-steps__icon"
            />
            <p className="fee-steps__label">ASSESSMENT</p>
          </div>
          <div className="fee-steps__item">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/step-3.webp`}
              alt="Step 3 - Start Classes"
              className="fee-steps__icon"
            />
            <p className="fee-steps__label">START CLASSES</p>
          </div>
        </div>
      </section>

      {/* Testimonials Slider Section */}
      <section className="fee-testimonials-section">
        <div className="fee-testimonials__container">
          <h4 className="fee-testimonials__title">HERE'S WHAT OUR STUDENTS &amp; PARENT HAVE TO SAY!</h4>

          {/* Stars */}
          <div className="fee-testimonials__stars">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="fee-testimonials__star">★</span>
            ))}
          </div>

          {/* Slide Content */}
          <div className="fee-testimonials__slide">
            <p className="fee-testimonials__quote">
              {testimonials[activeSlide].quote}
            </p>
            <p className="fee-testimonials__name">{testimonials[activeSlide].name}</p>
          </div>

          {/* Arrows */}
          <button className="fee-testimonials__arrow fee-testimonials__arrow--prev" onClick={prevSlide} aria-label="Previous">&#8249;</button>
          <button className="fee-testimonials__arrow fee-testimonials__arrow--next" onClick={nextSlide} aria-label="Next">&#8250;</button>

          {/* Dots */}
          <div className="fee-testimonials__dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`fee-testimonials__dot ${i === activeSlide ? 'fee-testimonials__dot--active' : ''}`}
                onClick={() => goToSlide(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>



      {/* Consultation Section */}
      <ConsultationSection
        title="FREE CONSULTATION CALL - Ask From Experts"
        subtitle={
          <div className="consultation-section__custom-subtitle">
            <p>— Get answers to your questions — Enquire about our Holy Quran teaching services</p>
            <p>— Recommendations &amp; suggestions from experts</p>
          </div>
        }
      />
    </div>
  );
};

export default QuranClassesFee;


